<template>
  <div id="econtract-layer">
    <light-header></light-header>
    <div class="welcome-layer auto">
      <!-- <span v-if="userInfo.isAuthed === 'passAuth'">{{
        userInfo.account
      }}</span>
      <span> 欢迎使用正元签电子合同平台</span> -->
      <el-alert title="" type="info" closable class="auto" v-if="userClientConfig.bulletin != 1"
        @close="handleUserCloseBulletin">
        <div slot="title" class="flex-center">
          <div>
            <svg-icon iconClass="icon-speaker" style="width: 14px; height: 14px"></svg-icon>
          </div>
          <light-marquee :lists="bulletin" ref="bulletin"></light-marquee>
        </div>
      </el-alert>
    </div>
    <div class="auto work-layer">
      <div class="work-layer-left">
        <div class="work-center-card card">
          <h3>👏 欢迎回来{{ userScope.isAuthed == 'notAuth' ? "" : "，" }}{{ userScope.spaceName }}</h3>
          <div class="work-center-list">
            <div class="work-center-item" @click="handleWorkCenterItem(item.key)"
              v-for="(item, idx) in mapUserFunction().workCenter" :key="item.key">
              <img :src="item.icon" alt="">
              <div class="item-right">
                <div class="item-sup">
                  {{ item.sup }}
                </div>
                <div class="item-sub">
                  {{ item.sub }}
                </div>
              </div>
              <svg-icon iconClass="corner-tag" class="corner-tag" v-if="item.tag" />
            </div>
            <!-- <div class="work-center-item" @click="handleWorkCenterItem(item.key)">
              <img src="@/assets/images/home/seal-manage.png" alt="">
              <div class="item-right">
                <div class="item-sup">
                  电子签章管理
                </div>
                <div class="item-sub">
                  管理企业签章
                </div>
              </div>
            </div>
            <div class="work-center-item" @click="handleWorkCenterItem('contact')">
              <img src="@/assets/images/home/contact.png" alt="">
              <div class="item-right">
                <div class="item-sup">
                  通讯录
                </div>
                <div class="item-sub">
                  新增联系人
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="card list-card">
          <div class="card-top">
            <div class="top-item flex-center ">
              <div class="flex-center quick-item" @click="viewDistinctContractList('iSign')">
                <div class="flex-center">
                  <svg-icon iconClass="i-sign-light" class="space-icon"> </svg-icon>
                  <svg-icon iconClass="i-sign-light-active" class="space-icon active"> </svg-icon>
                  <span class="quick-item-title">待我签署</span>
                  <span style="color: #448DF7;">{{ userContractInfo.iSign }}</span>
                </div>

                <svg-icon iconClass="arrow" class="icon-arrow"> </svg-icon>
              </div>

            </div>
            <div class="top-item flex-center ">
              <div class="flex-center quick-item" @click="viewDistinctContractList('otherSign')">
                <div class="flex-center">
                  <svg-icon iconClass="other-sign-light" class="space-icon"> </svg-icon>
                  <svg-icon iconClass="other-sign-light-active" class="space-icon active"> </svg-icon>
                  <span class="quick-item-title">待他签署</span>
                  <span style="color: #8A34FA;">{{ userContractInfo.otherSign }}</span>
                </div>
                <svg-icon iconClass="arrow" class="icon-arrow"> </svg-icon>
              </div>

            </div>
            <div class="top-item flex-center ">
              <div class="flex-center quick-item" @click="viewDistinctContractList('finish')">
                <div class="flex-center">
                  <svg-icon iconClass="finish-light" class="space-icon"> </svg-icon>
                  <svg-icon iconClass="finish-light-active" class="space-icon active"> </svg-icon>
                  <span class="quick-item-title">签署完成</span>
                  <span style="color: #00B42A;">{{ userContractInfo.finish }}</span>
                </div>
                <svg-icon iconClass="arrow" class="icon-arrow"> </svg-icon>
              </div>

            </div>
          </div>
          <div class="list-title">
            <h3>最近合同</h3>
            <el-button type="text" class="view-btn" @click="viewAllContractList">查看全部</el-button>
          </div>
          <div class="table-wrap">
            <!-- :header-cell-style="{ background: '#F2F3F5', color: '#1D2129', fontWeight: 500, padding: '12px 10px' }" -->
            <el-table :data="recentContractData" :cell-style="getCellStyle">
              <el-empty description="暂时没有近期合同" slot="empty" :image="require('@/assets/images/home/default.png')"
                :image-size="220" style="padding-top: 30px;">
              </el-empty>
              <el-table-column prop="taskName" label="合同主题" width="250px" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.recentFinish == 'yes'" type="danger" size="mini" color="#FFEBE7" style="margin-right: 10px;">新完成</el-tag>
                  <span>{{ scope.row.taskName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="合同状态" width="170px" >
                <template slot-scope="scope">
                  <div class="cell-item" v-if="scope.row.status == 'finish'">
                    <span class="status-dot dot-succeed"></span>
                    <span>签署完成</span>
                  </div>
                  <div class="cell-item" v-if="scope.row.status == 'iSign'">
                    <span class="status-dot dot-me"></span>
                    <span>待我签署</span>
                  </div>
                  <div class="cell-item" v-if="scope.row.status == 'otherSign'">
                    <span class="status-dot dot-other"></span>
                    <span>待他签署</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="initiatorName" width="170" label="发起人/企业" show-overflow-tooltip></el-table-column>
              <el-table-column prop="signerName" width="170" label="签署人/企业" show-overflow-tooltip></el-table-column>
              <el-table-column prop="taskType" label="签署截止日" width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="cell-item">
                    {{ scope.row.signExpireTime }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="signFinishTime" label="签署完成日" width="120" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="date" label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" class="operate-btn" @click="handleContractItemOperate('view', scope.row)">查看
                  </el-button>
                  <el-button type="text" class="operate-btn" v-if="scope.row.status == 'iSign' ||
                    scope.row.status == 'signingApprovalFailed'
                    " @click="handleContractItemOperate('sign', scope.row)">签署
                  </el-button>
                  <el-button type="text" class="operate-btn"
                    v-if="scope.row.status == 'finish' || scope.row.status == 'cancel'"
                    @click="handleContractItemOperate('dl', scope.row)">下载
                  </el-button>

                  <el-button type="text" class="operate-btn grey" v-if="scope.row.status == 'iSign' && scope.row.initiateUser == 'no' ||
                    scope.row.status == 'signingApprovalFailed'
                    " @click="handleContractItemOperate('reject', scope.row)">拒签
                  </el-button>
                  <el-button type="text" class="operate-btn grey"
                    v-if="(scope.row.status == 'otherSign' || scope.row.status == 'iSign') && scope.row.initiateUser == 'yes'"
                    @click="handleContractItemOperate('recall', scope.row)">撤回
                  </el-button>
                  <el-button type="text" class="operate-btn grey"
                    v-if="scope.row.status == 'finish' && scope.row.taskType != 'relieve' && scope.row.initiateUser == 'yes'"
                    @click="handleContractItemOperate('relieve', scope.row)">作废
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>
      </div>
      <div class="work-layer-right">
        <div class="sticky-wrap">
          <div class="user-center-card card">
            <div class="card-top">
              <svg-icon :iconClass="userScope.spaceType && userScope.spaceType == 'company' ? 'company' : 'person'"
                class="space-icon"></svg-icon>
              <!-- <img
                :src="userScope.spaceType == 'company' ? require('@/assets/images/home/space-company.png') : require('@/assets/images/global/user@2x.png')"
                alt="" class="space-icon"> -->
              <div class="card-right">
                <div class="right-sup">{{ userScope.computedSpaceName }}</div>
                <div class="right-sub">
                  <svg-icon :iconClass="userScope.computedSpaceAuth.name" alt=""
                    :style="{ width: userScope.computedSpaceAuth.width, height: userScope.computedSpaceAuth.height }"></svg-icon>
                  <span class="user-role-tag"
                    v-if="userScope.isAuthed == 'passAuth' && userScope.spaceType == 'company' && userScope.isSpaceOwner === 'yes'">管理员</span>
                  <span class="user-role-tag"
                    v-if="userScope.isAuthed == 'passAuth' && userScope.spaceType == 'company' && userScope.isSpaceOwner === 'no'">经办人</span>

                  <el-button type="text" class="auth-btn" @click="toAuth()" v-if="userScope.isAuthed == 'notAuth'">去认证<i
                      class="el-icon-arrow-right" style="font-size: 10px;"></i></el-button>
                  <el-popover placement="bottom" title="认证失败原因" width="245" trigger="click" popper-class="auth-reason-pop"
                    v-model="authReasonPopShow">
                    <div class="content">{{ userScope.rejectCompanyAuthReason }}</div>
                    <div class="bottom">
                      <el-button plain @click="authReasonPopShow = false">知道了</el-button>
                      <el-button type="primary" @click="toAuth('edit')">重新认证</el-button>
                    </div>
                    <el-button slot="reference" type="text" class="auth-btn"
                      v-show="userScope.isAuthed == 'rejectPersonAuth' || userScope.isAuthed == 'rejectCompanyAuth'">查看原因</el-button>
                  </el-popover>


                </div>
              </div>
            </div>
            <div class="card-bottom">
              <div class="flex-just bottom-top">
                <div>
                  <span class="text">
                    剩余发起签署：
                  </span>
                  <span class="big" :class="{ 'red': userScope.surplus == 0 }">
                    {{ userScope.surplus }}
                  </span>
                </div>
                <el-button type="text" class="buy-btn" @click="toCart()" v-if="mapUserFunction().buySet"
                  v-show="userScope.isAuthed == 'passAuth'">购买套餐<i class="el-icon-arrow-right"
                    style="font-size: 13px;"></i></el-button>
              </div>
              <el-button type="primary" class="large-btn" @click="userScope.userCenterBtn.fn"
                :disabled="userScope.isAuthed !== 'passAuth'">{{
                  userScope.userCenterBtn.txt
                }}</el-button>
            </div>
          </div>
          <div class="card help-card">
            <h3>帮助中心</h3>
            <div class="qa-list">
              <div class="qa-item"
                   v-for="(item, idx) in qaList" :key="idx"
                   @click="getQuestionView(item.columnId)"
                   >
                <span>{{ idx + 1 }}、{{ item.problemName }}</span>
                <i class="el-icon-arrow-right" style="font-size: 6px; color: #ccc;"></i>
              </div>
            </div>
            <div>
              <el-button type="text" class="view-btn" @click="handleViewHelpList">查看全部<i class="el-icon-arrow-right"
                  style="font-size: 13px;margin-left: 2px;"></i></el-button>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { getInfoApi } from "@/api/common";
import { getUserAccountInfo } from "@/api/global";
import {
  getSpaceDetailInfo,
  getUserSpaceInfo,
  replyInviteUserApi,
  deleteCompanyApi,
  setTenantApi,
  setTenantIdApi,
  companyAuthAndSealCon,
} from "@/api/home";
import {
  signBeforeCheck,
  downloadContractApi,
  downloadFinishedTasksAfter,
  updateTaskStatus2Reject,
  contractCountApi,
  getRecentContractDataList,
  recallContractApi
} from "@/api/space/contracts";
import {
  getRelieveInfo
} from "@/api/sign/sign";
import { getConsoleUrl } from "@/utils/auth";
import { downloadFile } from "@/utils/index";
import { mapState } from "vuex";
import lightHeader from "@/components/lightHeader";
import lightMarquee from "@/components/lightMarquee";
import {problemListOpen} from "@/api/doccenter/doccenter";
// import M from "minimatch";

const lauchWorkCenterCompany = {
  key: "launch",
  sup: "发起签署",
  sub: "上传合同指定签署方",
  icon: require("@/assets/images/home/launch-sign.png"),
  tag: true
}

const lauchWorkCenterPerson = {
  key: "launch",
  sup: "发起签署",
  sub: "上传合同指定签署方",
  icon: require("@/assets/images/home/launch-sign.png"),
  tag: true
}


const sealManageWorkCenter = {
  key: "seal-manage",
  sup: "电子签章管理",
  sub: "管理企业印章",
  icon: require("@/assets/images/home/seal-manage.png"),
}

const contactWorkCenter = {
  key: "contact",
  sup: "通讯录",
  sub: "新增联系人",
  icon: require("@/assets/images/home/contact.png"),
}

const applyWorkCenter = {
  key: "apply",
  sup: "审批管理",
  sub: "管理用章审批",
  icon: require("@/assets/images/home/apply.png"),
}

const eSealWorkCenter = {
  key: "e-seal",
  sup: "电子签名管理",
  sub: "管理个人签名",
  icon: require("@/assets/images/home/e-seal.png"),
}

export default {
  data() {
    return {
      userScope: { spaceName: "", computedSpaceName: "", computedSpaceAuth: { name: "" }, surplus: "", userCenterBtn: { fn: "", txt: "" } },
      userRoleConfig: {
        'company': {
          'type': 'company',
          'workCenter': [lauchWorkCenterCompany, sealManageWorkCenter, contactWorkCenter],
          'buySet': true,
          'userCenterBtn': {
            'txt': '企业管理后台',
            'fn': () => {
              this.toConsole();
            }
          }
        },
        'agent': {
          'type': 'agent',
          'workCenter': [lauchWorkCenterCompany, applyWorkCenter, contactWorkCenter],
          'buySet': false,
          'userCenterBtn': {
            'txt': '企业管理后台',
            'fn': () => {
              this.toConsole();
            }
          }
        },
        'person': {
          'type': 'person',
          'workCenter': [lauchWorkCenterPerson, eSealWorkCenter, contactWorkCenter],
          'buySet': true,
          'userCenterBtn': {
            'txt': '账号设置',
            'fn': () => {
              this.$router.push('/user/info')
            }
          }
        }
      },
      userClientConfig: {},
      recentContractData: [],
      bulletin: ["欢迎使用正元安服电子合同服务一站式在线签约平台，北京正元安服科技有限公司由吉大正元信息技术股份有限公司于2019年7月投资成立，是中国领先的信息安全专业服务提供商。正元安服依托吉大正元在密码领域及云安全行业的技术积淀、品牌优势、创新理念、项目经验和客户资源，为用户提供基于密码技术的云安全服务。"],
      qaList: [
        // {
        //   question: '如何自定义登录账号名？',
        // }, {
        //   question: '如何进行个人实名认证？',
        // }, {
        //   question: '如何制作个人印章？',
        // }, {
        //   question: '如何进行企业实名认证？',
        // }, {
        //   question: '如何制作企业印章？',
        // }, {
        //   question: '如何发起签约？',
        // }, {
        //   question: '如何签署合同？',
        // }, {
        //   question: '如何购买合同套餐？',
        // }, {
        //   question: '如何设置签署密码？',
        // }, {
        //   question: '如何变更企业信息？',
        // }
      ],
      getSpaceDetailLoading: false,
      authReasonPopShow: false,
    };
  },
  components: {
    lightHeader,
    lightMarquee
  },
  computed: {
    ...mapState(["userInfo", "spaceInfoList", "companyList", "currentSpace", "userContractInfo"]),
  },
  created() {

    this.initGetUserSpaceInfo();
    // 初始化用户信息
    this.initGetUserAccountInfo();
    // 初始化系统首页信息
    this.initGetSpaceDetailInfo();
    this.initGetRecentContractDataList();
    this.initGetContractCount();
    // 初始化用户配置行为
    this.userClientConfig = localStorage.getItem("config") ? JSON.parse(localStorage.getItem("config")) : {};

  },
  mounted() {

    this.$bus.$on("emitSpaceChange", (data) => {
      this.initGetSpaceDetailInfo();
      this.initGetRecentContractDataList();
      this.initGetContractCount();
      this.initProblemList();
    });

    // vue实例挂在后延迟执行弹窗，避免弹窗背景色与home白色之间衔接过快导致的闪动感
    setTimeout(() => {
      this.checkPwdOut();
      this.checkCompanyAuth();
      this.checkCompanySeal();
    },1500)

    this.initProblemList();
  },
  updated() {

  },
  beforeDestroy() {
    if (this.userClientConfig.bulletin != 1) {
      clearInterval(this.$refs.bulletin.timer);
    }
    //销毁监听事件
    this.$bus.$off("emitSpaceChange");
  },
  methods: {

    getQuestionView (columnId) {
      const url = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONTRACT_URL) ? GLOBAL_CONFIG.APP_CONTRACT_URL : GLOBAL_CONFIG.APP_CONTRACT_URL) + 'documentCenter'
      window.open(url + "?columnId="+columnId,"_blank")
    },

    initProblemList () {
      getSpaceDetailInfo().then((res) => {
        let userType = res.data.spaceType
        if (res.data.isSpaceOwner == "no"){
          userType = "companyAgent"
        }
        problemListOpen({"inUserType":userType}).then((res) => {
          this.qaList = res.data
        })
      })
    },

    checkCompanyAuth () {
      getSpaceDetailInfo().then((res) => {
        if (res.code === 200) {
          let thisUserInfo = res.data;
          if (thisUserInfo.isAuthed == 'notAuth' && thisUserInfo.spaceType == 'company'
              && thisUserInfo.companyCheckAuthCode == 0) {
            this.$confirm("您还没有完成企业身份认证，是否立即认证？", "温馨提示", {
              confirmButtonText: "立即认证",
              cancelButtonText: "稍后再说",
              type: "warning",
              center: true,
              showClose: false,
              closeOnClickModal: false,
            }).then(() => {
              this.$router.push({
                path: "/company-auth-info",
              });
            }).catch(() => {
            }).finally(() => {
              companyAuthAndSealCon({"companyCheckAuthCode":"1"}).then((res) => {})
            });
          }
          companyAuthAndSealCon({"companyCheckAuthCode":"1"}).then((res) => {})
        }
      })
    },

    checkCompanySeal () {
      getSpaceDetailInfo().then((res) => {
        if (res.code === 200) {
          let thisUserInfo = res.data;
          if (thisUserInfo.sealNumber == 0 && thisUserInfo.spaceType == 'company' && thisUserInfo.isAuthed == 'passAuth'
              && thisUserInfo.companyCheckSealCode == 0) {
            this.$confirm("您还没有制作企业印章，是否立即制作？", "温馨提示", {
              confirmButtonText: "去制章",
              cancelButtonText: "稍后再说",
              type: "warning",
              center: true,
              showClose: false,
              closeOnClickModal: false,
            }).then(() => {
              this.toConsolePathSeal()
            }).catch(() => {
            }).finally(() => {
              companyAuthAndSealCon({"companyCheckSealCode":"1"}).then((res) => {})
            });
          }
          companyAuthAndSealCon({"companyCheckSealCode":"1"}).then((res) => { })
        } else {
          console.log(res)
        }
      })
    },

    checkPwdOut () {
      getSpaceDetailInfo().then((res) => {
        if (res.code === 200) {
          let thisUserInfo = res.data;
          if (thisUserInfo.pwdRemindStr != "ok" && thisUserInfo.lastChangePwdCode == 0) {
            this.$confirm(thisUserInfo.pwdRemindStr, "温馨提示", {
              confirmButtonText: "立即修改",
              cancelButtonText: "稍后再说",
              type: "warning",
              center: true,
              showClose: false,
              closeOnClickModal: false,
            }).then(() => {
              this.$router.push({
                path: "/user/info",
              });
            }).catch(() => {
            }).finally(() => {
              companyAuthAndSealCon({"lastChangePwdCode":"1"}).then((res) => {})
            })
          }
          companyAuthAndSealCon({"lastChangePwdCode":"1"}).then((res) => {})
        } else {
          console.log(res)
        }
      })
    },

    getCellStyle({ column }) {
      //针对Safari表格width与showOverflowTooltip暂不能共存异常
      const tempWidth = column.realWidth || column.width
      if (column.showOVerflowTooltip) {
        return {
          color: '#313843',
          fontWeight: 400,
          padding: '12px 10px',
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }
      return {
        color: '#313843',
        fontWeight: 400,
        padding: '12px 10px'
      }

    },
    mapUserFunction(userScope = this.userScope) {
      const role = userScope.spaceType == 'company' ? (userScope.isSpaceOwner == 'yes' ? 'company' : 'agent') : 'person';
      return this.userRoleConfig[role];
    },
    computeSpaceName(userScope = this.userScope) {
      if (userScope.isAuthed == 'notAuth') {
        return userScope.spaceType == 'person' ? '个人' : '企业';
      } else {
        return userScope.spaceName ? userScope.spaceName : '';
      }
    },
    computeSpaceItemAuth(userScope = this.userScope) {
      if (userScope.isAuthed == 'notAuth') {
        return {
          name: 'not-auth-rect',
          width: '48px',
          height: '20px'
        }
      } else if (userScope.isAuthed == 'passAuth') {
        return {
          name: 'auth-done-rect',
          width: '64px',
          height: '20px'
        }
      } else if (userScope.isAuthed == 'rejectPersonAuth' || userScope.isAuthed == 'rejectCompanyAuth') {
        return {
          name: 'auth-fail-rect',
          width: '76px',
          height: '20px'
        }
      } else if (userScope.isAuthed == 'inPersonAuth' || userScope.isAuthed == 'inCompanyAuth') {
        return {
          name: 'auth-ing-rect',
          width: '48px',
          height: '20px'
        }
      }
    },
    initGetUserAccountInfo() {
      getUserAccountInfo().then((res) => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          if (
            res.data.isAuthed == "rejectCompanyAuth" &&
            res.data.rejectCompanyAuthReason
          ) {
            this.alertMsg = res.data.rejectCompanyAuthReason;
            this.$confirm(res.data.rejectCompanyAuthReason, "认证未通过", {
              confirmButtonText: "重新认证",
              cancelButtonText: "知道了",
              type: "warning",
              center: true,
              showClose: false
            })
              .then(() => {
                this.toAuth('edit');
              })
              .catch(() => { });
          }
          this.$store.commit("SET_USER_INFO", res.data); // 保存用户信息
          // if (this.$store.state.userInfo.isFirstLogin) {
          //   this.$router.push({
          //     path: '/perfect-info'
          //   })
          // }
        }
      });
    },
    initGetUserSpaceInfo() {
      getUserSpaceInfo().then((res) => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          let idx = 0;
          if (this.currentSpace && this.currentSpace.tenantId) {
            res.data.spaceInfoArray.map((_item, _idx) => {
              if (_item.tenantId == this.currentSpace.tenantId) {
                _item.checked = true;
                idx = _idx;
              } else {
                _item.checked = false;
              }
            })
          } else {
            idx = 0;
            res.data.spaceInfoArray.map((_item, _idx) => {
              if (_idx == 0) {
                _item.checked = true;
              } else {
                _item.checked = false;
              }
            })
          }
          this.$store.commit("SET_CURRENT_SPACE", { tenantId: res.data.spaceInfoArray[idx].tenantId, space: res.data.spaceInfoArray[idx] });
          this.$store.commit("SET_SPACE_INFO_LIST", res.data.spaceInfoArray);
        }
      });
    },
    initGetSpaceDetailInfo() {
      this.getSpaceDetailLoading = true;
      getSpaceDetailInfo().then((res) => {
        this.getSpaceDetailLoading = false;
        if (res.code === 200) {
          res.data.computedSpaceName = this.computeSpaceName(res.data);
          res.data.userCenterBtn = this.mapUserFunction(res.data).userCenterBtn;
          res.data.computedSpaceAuth = this.computeSpaceItemAuth(res.data);
          this.userScope = res.data;
          this.$forceUpdate();
        }
      }).catch(() => {
        this.getSpaceDetailLoading = false;
      });
    },

    initGetRecentContractDataList() {
      getRecentContractDataList().then((res) => {
        if (res.code === 200) {
          this.recentContractData = res.data.taskInfoArray;
        }
      });
    },

    initGetContractCount() {
      contractCountApi()
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.$store.commit("SET_USER_CONTRSCT_INFO", res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleUserCloseBulletin() {
      let userConfig = localStorage.getItem("config") ? JSON.parse(localStorage.getItem("config")) : { bulletin: 0 };
      userConfig.bulletin = 1;
      localStorage.setItem("config", JSON.stringify(userConfig));
      clearInterval(this.$refs.bulletin.timer);
      this.$refs.bulletin.timer = null;
    },


    toConsole() {
      setTenantIdApi({ tenantId: this.currentSpace.tenantId }).then((res) => {
        if (res.code != 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          const consoleHref = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL) ? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL);
          window.open(consoleHref, "_blank");
        }
      });
    },
    toConsolePathSeal() {
      setTenantIdApi({ tenantId: this.currentSpace.tenantId }).then((res) => {
        if (res.code != 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          let consoleHref = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL) ? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL);
          consoleHref += "sealManager/seal";
          window.open(consoleHref, "_blank");
        }
      });
    },
    viewDistinctContractList(status) {
      this.$router.push({
        path: "/space/contract-list?status=" + status,
      });
    },
    viewAllContractList() {
      this.$router.push({
        path: "/space/contract-list?status=all",
      });
    },

    toCart() {
      this.$router.push({
        path: "/cart/cart",
      });
    },

    handleWorkCenterItem(type) {
      switch (type) {
        case 'launch':
          if (this.userScope.isAuthed == 'passAuth') {
            this.$router.push({
              path: "/temp-create",
              query: {
                from: this.$route.fullPath.replace(/\?/, "!!"),
              },
            });
          }
          break;
        case 'seal-manage':
          // this.$router.push({
          //   path: "/user/seal",
          // });
          if (this.userScope.isAuthed == 'passAuth') {
            this.toConsolePathSeal();
          }
          break;
        case 'contact':
          this.$router.push({
            path: "/user/contact"
          });
          break;
        case 'apply':
          this.$router.push({
            path: "/approve/list?status=myapproval"
          });
          break;
        case 'e-seal':
          this.$router.push({
            path: "/user/seal",
          });
          break;
        default: return;
      }
    },


    handleContractItemOperate(commandType, { signId, taskType, taskName, taskId }) {
      switch (commandType) {
        case 'view':
          this.$router.push({
            path: "/temp-info",
            query: {
              signId,
              taskType
            },
          });
          break;
        case 'sign':
          signBeforeCheck({
            signId
          }).then(res => {
            if (res.code == 200) {
              if (res.data.signBeforeCheck) {
                this.$router.push({
                  path: "/signing",
                  query: {
                    signId,
                    signType: this.currentSpace.companyId ? "1" : "0",
                    companyId: this.currentSpace.companyId,
                    taskName: taskName
                  },
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.signBeforeCheckInfo,
                  type: "warning"
                });
              }

            } else {

            }
          })
          break;
        case 'dl':

          downloadFinishedTasksAfter({
            "taskId":taskId
          }).then((res) => {
            downloadContractApi({
              "signId" : signId
            }).then((resDon) => {
              downloadFile(resDon, taskName, res.data.resultFileType);
            }).catch((err) => {
              console.log(err);
            });
          }).catch((err) => {
            console.log(err);
          });

          // downloadContractApi({
          //   signId,
          // })
          //   .then((res) => {
          //     downloadFile(res, taskName, "zip");
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });

          break;
        case 'reject':
          this.$confirm("确定要拒签该合同吗？", "温馨提示", {
            confirmButtonText: "拒签",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
            showClose: false
          })
            .then(() => {
              updateTaskStatus2Reject({
                signId
              })
                .then((res) => {
                  if (res.code !== 200) {
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: "warning",
                    });
                  } else {
                    this.$message({
                      showClose: true,
                      message: "拒签成功！",
                      type: "success",
                    });
                    this.initGetRecentContractDataList();
                    this.initGetContractCount();
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch(() => { });
          break;
        case "recall":
          this.$confirm("确定要撤回该合同吗？", "温馨提示", {
            confirmButtonText: "撤回",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
            showClose: false
          })
            .then(() => {
              recallContractApi({
                signId
              })
                .then((res) => {
                  if (res.code !== 200) {
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: "warning",
                    });
                  } else {
                    this.$message({
                      showClose: true,
                      message: "撤回成功！",
                      type: "success",
                    });

                    this.initGetRecentContractDataList();
                    this.initGetContractCount();
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch(() => { });
          break;
        case 'relieve':
          this.$confirm("确定要作废该合同吗？", "温馨提示", {
            confirmButtonText: "作废",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
            showClose: false
          })
            .then(() => {
              getRelieveInfo({
                signId
              }).then((res) => {
                if (res.code !== 200) {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "warning",
                  });
                } else {
                  this.$router.push({
                    path: "/launchtask",
                    query: {
                      signId,
                    },
                  });
                }
              })
            })
            .catch(() => { });
          break;
        default: return;
      }
    },
    handleViewHelpList() {
      const fileUrl = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONTRACT_URL) ? GLOBAL_CONFIG.APP_CONTRACT_URL : GLOBAL_CONFIG.APP_CONTRACT_URL) + 'documentCenter';
      window.open(fileUrl, "_blank");
      // const fileUrl = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + 'pc/manual.pdf';
      // window.open(fileUrl, "_blank");
    },
    handleHelpItem(item) {
      const fileUrl = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + 'pc/manual.pdf';
      window.open(fileUrl, "_blank");
    },

    toFlow(tenantId, space) {
      setTenantIdApi({ tenantId }).then((res) => {
        if (res.code != 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.$store.commit("SET_CURRENT_SPACE", { tenantId, space });
          this.$router.push({
            path: "/temp-create",
            query: {
              from: this.$route.fullPath.replace(/\?/, "!!"),
            },
          });
        }
      });
    },
    jumpToSpace(tenantId, spaceType, space) {
      setTenantIdApi({ tenantId }).then((res) => {
        if (res.code != 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.$store.commit("SET_CURRENT_SPACE", { tenantId, space });
          this.$router.push({
            path: "/user-space/contracts",
            query: {
              status: spaceType ? spaceType : "all",
            },
          });
        }
      });
    },
    toAuth(userId) {
      if (this.userInfo.userType === "person") {
        this.$router.push({
          path: "/personal-auth-info",
        });
      } else {
        if (userId && typeof userId === "string") {
          this.$router.push({
            path: "/company-auth-info?edit=yes&re=yes",
          });
        } else {
          this.$router.push({
            path: "/company-auth-info",
          });
        }
      }
    },

    authHandle(type) {
      if (type === "personal") {
        this.$router.push({
          path: "/personal-auth-info",
        });
        localStorage.removeItem("vuex");
      } else {
        this.$router.push({
          path: "/company-auth-info",
        });
      }
    },


    toSpace(type, company) {
      if (type == "user") {
        this.$store.commit("SET_CURRENT_SPACE", {});
        this.$router.push({
          path: "/space/contract-list?status=all",
        });
      } else {
        this.$store.commit("SET_CURRENT_SPACE", company);
        this.$router.push({
          path:
            "/company-space/contracts?status=all&companyId=" + company.companyId,
        });
      }
    },
    toUserCenter() {
      this.$router.push({
        path: "/user/info",
      });
    },
    agreeHandle(company) {
      if (!this.userInfo.isAuthed) {
        this.$confirm(`您需要完成实名认证`, "加入企业", {
          confirmButtonText: "去实名认证",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          showClose: false
        })
          .then(() => {
            this.toAuth(userId);
          })
          .catch(() => { });

        return;
      }

      this.$confirm(
        `您同意 ${company.adminName} 的邀请加入 ${company.companyName}`,
        "同意加入企业",
        {
          confirmButtonText: "确定",
          cancelButtonText: "关闭",
          type: "warning",
          center: true,
          showClose: false
        }
      )
        .then(() => {
          replyInviteUserApi({
            companyId: company.companyId,
            flag: "agree",
          })
            .then((res) => {
              if (res.code !== "0") {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });

                this.getCompanyListHandle();
              } else {
                this.$message({
                  showClose: true,
                  message: "加入成功！",
                  type: "success",
                });

                setTimeout(() => {
                  this.toSpace("company", company);
                }, 1000);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.getCompanyListHandle();
        });
    },
    rejectHandle(company) {
      this.$confirm(
        `您拒绝加入该企业，确定后该企业空间将被删除`,
        "拒绝加入企业",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          showClose: false
        }
      )
        .then(() => {
          replyInviteUserApi({
            companyId: company.companyId,
            flag: "disagree",
          }).then((res) => {
            if (res.code !== "0") {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              this.getCompanyListHandle();
            }
          });
        })
        .catch(() => { });
    },
  },
  directives: {
    hover: {
      inserted: function (el) {
        var img = el.querySelectorAll("img");
        el.onmouseover = function () {
          img[0].style.display = "none";
          img[1].style.display = "block";
        };

        el.onmouseout = function () {
          img[0].style.display = "block";
          img[1].style.display = "none";
        };
      },
    },
  },
};
</script>

<style lang="scss">
.el-tooltip__popper.is-dark {
  background: rgba(0, 0, 0, .7) !important;
}

.el-table::before {
  content: '';
  display: none;
}

.el-table .el-table__fixed-right::before {
  content: "";
  display: none;
}


.el-empty .el-empty__description {
  margin-top: 0;
  line-height: normal;
}



// .space-handle .add-space:hover {
//   background: #66b1ff !important;
//   border-color: #66b1ff !important;
//   transition: 0.1s;
// }


// .el-dropdown {
//   height: 20px;
// }

// .el-dropdown-menu__item {
//   text-align: center;
// }

// .el-dropdown-menu__item:not(.is-disabled):hover,
// .el-dropdown-menu__item:focus {
//   background-color: rgba(46, 174, 253, 0.1) !important;
//   color: #2eaefd !important;
// }

.el-popover.auth-reason-pop {
  padding: 20px;
  min-height: 174px;
  position: relative;

  .el-popover__title {
    font-size: 14px;
    font-weight: 500;
    color: #1D2129;
    line-height: 22px;
    margin-bottom: 8px;
  }

  .content {
    font-size: 14px;
    font-weight: 400;
    color: #86909C;
    line-height: 18px;
    padding-bottom: 50px;
  }

  .bottom {
    position: absolute;
    bottom: 20px;
    right: 20px;

    .el-button {
      padding: 5px 16px;
      font-size: 14px;
      font-weight: 400;
      color: #3982F7;
      line-height: 22px;
      border-color: #3982F7;

      &.el-button--primary {
        color: #fff;
        margin-left: 16px;
        background-color: #3982F7;
      }

      &:hover {
        opacity: .7;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#econtract-layer {
  background: #F3F3F7;
  min-height: calc(100vh);
}

.card {
  background: #fff;
}

.welcome-layer {
  font-size: 18px;
  color: #333333;
  margin: 20px 20px 16px;

  .el-alert {
    height: 42px;
    background: #E8EFF9;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #E2E7EE;
    font-size: 12px;
    font-weight: 500;
    color: #313843;
    line-height: 20px;
    padding-right: 48px;

    /deep/ .svg-icon {
      width: 14px;
      height: 14px;
      margin-right: 20px;
      display: block;
    }

    /deep/ .el-alert__closebtn {
      font-size: 17px;
      right: 20px;
    }
  }
}

.work-layer {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  padding: 0 20px;

  .work-layer-left {
    width: calc(100% - 296px - 16px);

    .work-center-card {
      width: 100%;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #FFFFFF;
      padding: 20px 20px 30px;

      h3 {
        font-size: 20px;
        font-weight: 500;
        color: #1D2129;
        line-height: 28px;
      }

      .work-center-list {
        margin-top: 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .work-center-item {
          width: calc((100% - (30px * 2)) / 3);
          height: 94px;
          background: #FAFAFB;
          border-radius: 10px;
          display: flex;
          align-items: center;
          padding: 17px 8px 17px 30px;
          transition: ease all .4s;
          position: relative;
          cursor: pointer;
          overflow: hidden;

          &:hover {
            background: #fff;
            box-shadow: 0px 4px 16px 0px rgba(176, 183, 199, 0.2);
            transform: translateY(-4px);
            transition: ease all .4s;
          }

          img {
            width: 60px;
          }

          .item-right {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 5px 0 9px;
            margin-left: 20px;
            min-width: 45px;

            .item-sup {
              font-size: 18px;
              font-weight: 500;
              color: #383D47;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .item-sub {
              font-size: 13px;
              font-weight: 400;
              color: #6B7373;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .corner-tag {
            width: 36px;
            height: 20px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }

    .list-card {
      margin-top: 16px;
      border-radius: 10px;
      height: 601px;

      .card-top {
        border-bottom: 1px solid #F2F3F5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 64px;

        .top-item {
          padding: 0 50px 0 50px;
          margin: 12px 0;
          border-right: 1px solid #F2F3F5;
          width: 33.33%;
          color: #131414;
          overflow: hidden;

          &:nth-last-of-type(1) {
            border-right: none;
          }


          .quick-item {
            width: 100%;
            cursor: pointer;
            justify-content: space-between;

            &:hover {

              span:nth-of-type(1) {
                color: #165DFF;
                transition: all ease .4s;
              }

              .space-icon {
                display: none;

                &.active {
                  display: block;
                }
              }

              .icon-arrow {
                opacity: 1;
                transform: translateX(10px);
              }
            }

            .icon-arrow {
              width: 16px;
              height: 16px;
              opacity: 0;
              transition: all ease .4s;
            }
          }

          .space-icon {
            width: 18px;
            height: 18px;
            margin-right: 8px;
            transition: all ease .4s;

            &.active {
              display: none;
            }
          }

          .quick-item-title {
            white-space: nowrap;
            overflow: hidden;
          }

          span {
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            color: #131414;
            line-height: 24px;
            margin-right: 20px;
          }
        }
      }

      .list-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 20px;

        h3 {
          font-size: 20px;
          font-weight: 500;
          color: #1D2129;
        }

        .view-btn {
          width: 76px;
          height: 36px;
          line-height: 34px;
          font-size: 14px;
          font-weight: 400;
          color: #165DFF;
          padding: 0;
          text-align: center;
          border-radius: 6px;

          &:hover {
            opacity: .7;
          }

          &:active {
            background: #F8F9FC;
          }
        }
      }

      .table-wrap {
        padding: 0 20px 20px;
        min-height: 435px;

        /deep/ .cell {
          // padding-left: 6px;
          // padding-right: 0;
          // line-height: 1;
          // padding: 0 !important;
          padding-left: 20px;
          padding-right: 20px;
        }

        .el-table /deep/ .el-table__cell {
          height: 46px;
          padding: 0 !important;
        }

        // /deep/ .el-table__fixed-right {
        //   box-shadow: -2px 0px 2px 0px rgba(0, 0, 0, 0.1);
        // }

        .cell-item {
          display: flex;
          align-items: center;

          .status-dot {
            display: block;
            width: 6px;
            height: 6px;
            background: #8A34FA;
            overflow: hidden;
            border-radius: 100%;
            margin-right: 8px;

            &.dot-succeed {
              background: #00B42A;
            }

            &.dot-me {
              background: #448DF7;
            }

            &.dot-other {
              background: #8A34FA;
            }
          }
        }



        // .el-button--text {
        //   font-size: 14px;
        //   font-weight: 400;
        //   color: #165DFF;
        //   padding: 0;

        //   &.grey {
        //     color: #86909C;
        //   }

        //   &:hover {
        //     opacity: .7;
        //   }

        // }

        // .el-button+.el-button {
        //   margin-left: 11px;
        // }
      }
    }
  }

  .work-layer-right {
    width: 296px;

    .sticky-wrap {
      position: sticky;
      top: 0;
      right: 0;
    }

    .user-center-card {
      width: 100%;
      height: 200px;
      background: #FFFFFF;
      border-radius: 10px;
      padding: 20px 20px 20px 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .card-top {
        height: 86px;
        display: flex;
        align-items: flex-start;
        border-bottom: 1px solid #F2F3F5;

        .space-icon {
          width: 50px;
          height: 50px;
        }

        .card-right {
          margin-left: 12px;

          .right-sup {
            font-size: 16px;
            font-weight: 500;
            color: #3D3D3D;
            // line-height: 24px;
            width: 192px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-height: 21px;
          }

          .right-sub {
            margin-top: 7px;
            display: flex;
            align-items: center;

            .svg-icon {
              height: 20px;
            }

            .user-role-tag {
              font-size: 12px;
              font-weight: 400;
              color: #165DFF;
              line-height: 18px;
              margin-left: 16px;
            }

            .auth-btn {
              font-size: 12px;
              margin-left: 12px;
              padding: 0;
            }
          }
        }
      }

      .card-bottom {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .bottom-top {
          margin: 16px 0;
          height: 24px;
        }

        .text {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
        }

        .big {
          font-size: 16px;
          font-weight: 400;
          color: #666;

          &.red {
            color: #EB6069;
          }

        }

        .buy-btn {
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #1D2129;
          line-height: 24px;
          padding: 0;

        }

        .large-btn {
          width: 100%;
          height: 40px;
          line-height: 39px;
          padding: 0;
          border-radius: 6px 6px 6px 6px;
          background: #3F7BF9;
          border: none;
          font-size: 15px;
          font-weight: 500;
          color: #FFFFFF;

          &:hover {
            background: #165DFF;
          }

          &:active {
            outline: 4px solid rgba(84, 137, 249, 0.2);
          }

          &.is-disabled {
            background: #5489F9;
            outline: none;
            border: none;
            opacity: .5;
          }
        }
      }
    }

    .help-card {
      margin-top: 16px;
      padding: 0 20px 20px;
      border-radius: 10px;
      height: 601px;

      h3 {
        font-size: 18px;
        font-weight: 500;
        color: #1D2129;
        height: 64px;
        line-height: 64px;
        border-bottom: 1px solid #F2F3F5;
      }

      .qa-list {
        height: 480px;
        padding: 20px 0;
        border-bottom: 1px solid #F2F3F5;

        .qa-item {
          padding: 10px 0;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;

          &:hover {
            color: #165DFF;
          }
        }
      }

      .view-btn {
        display: block;
        margin: 20px auto 0;
        font-size: 15px;
        font-weight: 500;
        color: #3982F7;
        padding: 0;
      }
    }
  }
}

.waiting-others-num-drop{
  color:#8A34FA;
}

.waiting-me-num-drop{
  color:#448DF7;
}

.sign-complete-num-drop{
  color:#00B42A;
}
</style>
<style>
.el-icon--right {
  margin-left: 2px !important;
  color: #165DFF;
  cursor: pointer;
}

.el-dropdown {
  margin-left: 11px;
  margin-right: 11px;
}
</style>
